import React, { useRef } from "react";
import { useLanguage } from '../hooks/LanguageContext';
import { getColor, nullCellColor, getSortedNumericValues, colorForMappedValue, legendQuantileStops } from "../../static/js/DataAlgoritms";
import locale from '../locales/ColorsDescriptionPanel.locale';

const softenColor = (rgb, factor = 0.3) => {
    const match = rgb.match(/\d+/g);
    if (!match) return rgb;
    let [r, g, b] = match.map(Number);
    r = Math.min(255, Math.round(r + (255 - r) * factor));
    g = Math.min(255, Math.round(g + (255 - g) * factor));
    b = Math.min(255, Math.round(b + (255 - b) * factor));
    return `rgb(${r}, ${g}, ${b})`;
};

const ColorsDescriptionPanel = ({ currentH3s, isCompetitors = false }) => {
    const { language } = useLanguage();
    const t = locale[language];
    const legendLogKeyRef = useRef("");

    const sortedValues = getSortedNumericValues(currentH3s);
    const min = sortedValues[0];
    const max = sortedValues[sortedValues.length - 1];

    if (min === undefined || max === undefined) {
        return null;
    }

    const mid = sortedValues[Math.floor(sortedValues.length / 2)];
    const oldMidColor = getColor(isCompetitors ? (max - (mid - min)) : mid, min, max);
    const newMidColor = colorForMappedValue(mid, sortedValues, isCompetitors);
    const legendLogKey = `${min}-${max}-${sortedValues.length}-${isCompetitors}-${mid}`;
    if (legendLogKeyRef.current !== legendLogKey) {
        legendLogKeyRef.current = legendLogKey;
        // #region agent log
        fetch('http://127.0.0.1:7591/ingest/d2880673-f438-4573-9075-68f79f8bcef7',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'da59d4'},body:JSON.stringify({sessionId:'da59d4',runId:'hex-legend',hypothesisId:'H8',location:'ColorsDescriptionPanel.jsx',message:'legend vs quantile',data:{min,max,mid,oldMidColor,newMidColor,isCompetitors,numericCount:sortedValues.length},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
    }

    const gradientStops = legendQuantileStops(sortedValues, isCompetitors)
        .map(({ color, pct }) => `${softenColor(color, 0.3)} ${Math.round(pct)}%`)
        .join(", ");

    return (
        <div className={"pinned-item right"}>
            <h1>{t.title}</h1>

            <div className={"pinned-item-row"}>
                <p>{t.colorArea.label}</p>
                <div className={"pinned-item-row-content"}>
                    <p style={{ textAlign: "right" }}>
                        {max?.toFixed(2) ?? t.colorArea.notDefined}
                    </p>
                    <div
                        className={"colors-description-panel"}
                        style={{
                            background: `linear-gradient(to right, ${gradientStops})`,
                        }}
                    />
                    <p style={{ textAlign: "left" }}>
                        {min?.toFixed(2) ?? t.colorArea.notDefined}
                    </p>
                </div>
            </div>

            <div className={"pinned-item-row"} style={{ marginTop: '1em' }}>
                <p>{t.noDataCell.label}</p>
                <div className={"pinned-item-row-content"} style={{ alignItems: "center", gap: "0.5em" }}>
                    <div
                        style={{
                            width: "40px",
                            height: "20px",
                            backgroundColor: nullCellColor(),
                            border: "1px solid #000",
                            borderRadius: "3px",
                        }}
                    />
                    <span style={{ fontSize: '0.9em', color: '#666' }}>
                        {t.noDataCell.description}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ColorsDescriptionPanel;